export default {
  email: v => /.+@.+\..+/.test(v) || 'Måste vara en giltig email',
  required: v => !!v || 'Fältet är obligatoriskt'
}
